export default __webpack_public_path__ + "static/media/edit-workout.fe1641b0.svg";